<template>
    <div>
        <div class="top_texts">
            <h3>Alle gegevens zijn compleet, u hoeft uw aanvraag alleen nog te ondertekenen.</h3>
            <p>
                Dit kunt u digitaal doen via SignRequest.com, <br/>
                U wordt hier automatisch naartoe gestuurd zodra u op 'Ondertekenen' klikt.
            </p>
        </div>
        <form>
            <input id="current_location_input" name="current_location_input" type="text"
                   v-model="current_location_input"/>
        </form>
        <div>
            <button class="btn btn-default pull-left" @click="$emit('prev_step')"
                    v-if="!loading">
                Vorige stap
            </button>
            <button class="btn btn-default pull-left is-disabled" v-else>
                Vorige stap
            </button>
            <button class="btn btn-primary pull-right" @click="get_sign_request_pdf"
                    :class="{'is-disabled': loading}">
                Ondertekenen
                <span v-if="loading">
                    <font-awesome-icon :icon="['fal', 'spinner']" spin></font-awesome-icon>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            contract: {},
            contract_urlsafe: {},
            connection_number: {
                type: String,
            },
            working: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                current_location_input: null,
                loading: false,
            };
        },
        methods: {
            get_sign_request_pdf() {
                const self = this;

                if (self.loading) {
                    return;
                }

                self.loading = true;

                if (self.current_location_input) {
                    // Honey pot trap
                    return;
                }

                self.$rest(
                    '/checkout/signup/service/user/get_sign_request_pdf/',
                    {
                        body: {
                            urlsafe: self.contract.urlsafe || self.contract_urlsafe,
                            confirmation_code: self.connection_number || null,
                        },
                    },
                ).then((response) => {
                    if ('sign_url' in response) {
                        window.open(response.sign_url, '_self');
                    }
                });
            },
        },
    };
</script>

<style scoped="scoped">
    #current_location_input {
        position: fixed;
        left: -100%;
    }
</style>
